import { render, staticRenderFns } from "./BlogByTag.vue?vue&type=template&id=27a46b01&"
import script from "./BlogByTag.vue?vue&type=script&lang=js&"
export * from "./BlogByTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports